export const employeeSchema = {
  emp_code: {
    type: String,
    required: true,
    length: {
      min: 1,
      max: 10,
    },
  },
  id_card: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: false,
  },
  title_th: {
    type: String,
    required: false,
  },
  first_name: {
    type: String,
    required: true,
  },
  last_name: {
    type: String,
    required: true,
  },
  first_name_th: {
    type: String,
    required: true,
  },
  last_name_th: {
    type: String,
    required: true,
  },
  nick_name: {
    type: String,
    required: true,
  },
  nick_name_th: {
    type: String,
    required: true,
  },
  birth_date: {
    type: String,
    required: false,
  },
  address: {
    type: String,
    required: false,
  },
  personal_email: {
    type: String,
    required: false,
  },
  nationality: {
    type: String,
    required: false,
  },
  phone: {
    type: String,
    required: false,
  },
  emergency_contact_name: {
    type: String,
    required: false,
  },
  emergency_relationship: {
    type: String,
    required: false,
  },
  emergency_phone_number: {
    type: String,
    required: false,
  },
  emergency_address: {
    type: String,
    required: false,
  },
  emergency_id_card: {
    type: String,
    required: false,
  },
  gender: {
    type: String,
    required: true,
  },
  image_url: {
    type: String,
    required: false,
  },
  resigned: {
    type: Boolean,
    required: false,
  },
  is_active: {
    type: Boolean,
    required: false,
  },
  marital_status: {
    type: String,
    required: false,
  },
  number_of_children: {
    type: String,
    required: false,
  },
  last_working_date: {
    type: Boolean,
    required: false,
  },
  last_effective_date: {
    type: Boolean,
    required: false,
  },
  remark: {
    type: String,
    required: false,
  },
  resign_remark: {
    type: String,
    required: false,
  },
  email: {
    type: String,
    required: true,
  },
  employee_type: {
    type: String,
    required: false,
  },
  line_manager_id: {
    type: String,
    required: false,
  },
  emp_bonus_mth: {
    type: String,
    required: false,
  },
  money_adjust_month: {
    type: String,
    required: false,
  },
  probation_complete_date: {
    type: String,
    required: false,
  },
  adjust_after_complete: {
    type: Boolean,
    required: false,
  },
  referral: {
    type: String,
    required: false,
  },
}

export const filterPersonal = values => {
  const _values = { ...values }
  Object.keys(values).map(key => {
    if (!employeeSchema[key]) {
      delete _values[key]
      return key
    } else if (_values[key] === null) {
      _values[key] = ''
    }
    return key
  })
  return _values
}



// WEBPACK FOOTER //
// ./src/components/new-employee/schema/personal-schema.js